import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  zh: {
    navList: [],
    btnData: {
      more: "了解更多",
      buy: "前往商城",
      jump_design_center: "前往设计中心",
      contact_us: "联系我们",
      about_wellingmer: "关于威力铭",
      submit_msg: "提交留言",
    },
    productData: {
      detailed_description: "详细说明",
      product_details: "产品详情",
    },
    shoppingData: {
      wellingmer_mall: "威力铭商城",
      design_center: "设计中心",
      // buy_more: "前往威力铭商城选购更多产品",
      buy_more: "点击跳转了解更多",
      // jump_design_center: "前往威力铭设计中心",
      jump_design_center: "敬请期待",
    },
    albumData: {
      title: "公司环境",
      subtitle: "威力铭公司相册",
    },
    serviceData: {
      title: "威力铭深耕行业",
      subtitle: "威力铭WEILIMING多年来坚持匠心制造，累计服务客户群体",
      service_clients: "服务客户",
      service_outlets: "服务网点",
      service_cities: "覆盖城市",
      service_reviews: "好评",
    },
    pathersData: {
      title: "他们选择了威力铭",
      subtitle: "日积月累、服务至上，威力铭业务覆盖了全国机构。",
    },
    aboutData: {
      submit_title: "提交留言",
      submit_subtitle: "您可随时提交留言，感谢信任威力铭！",
      name_placeholder: "请输入公司名称",
      phone_placeholder: "请输入联系电话",
      content_placeholder: "请输入内容",
      name_err: "公司名称不能为空",
      phone_err: "联系电话不能为空",
      content_err: "内容不能为空",
      submit_success: "提交成功",
      submit_error: "提交失败，请稍候再重试",
      service_time: "7x24小时服务",
      honor_title: "企业荣誉",
      honor_subtitle: "威力铭深耕行业多年，荣誉是最好的见证！",
    },
    footerData: {
      title_products: "产品",
      title_mall_and_design: "商城与设计中心",
      title_udi_search: "UDI查询",
      title_follow_wellingmer: "关注威力铭",
      title_contact_us: "联系我们",
      wellingmer_mall: "商城",
      design_center: "设计中心（敬请期待）",
      phone: "电话",
      email: "邮箱",
      address: "地址",
      query: "查询",
      query_placeholder: "请输入查询内容",
      more: "查看更多",
    },
    jobData: {
      title: "等你来挑战",
      subtitle: "威力铭诚聘英才，成为伙伴，给你提供更多的机会",
    },
    emptyTip: "敬请期待",
  },
  en: {
    navList: [],
    btnData: {
      more: "More",
      buy: "Buy",
      contact_us: "Contact Us",
      about_wellingmer: "About Wellingmer",
      submit_msg: "Message Submit",
      jump_design_center: "Design Center",
    },
    productData: {
      detailed_description: "Remark",
      product_details: "Product Detail",
    },
    shoppingData: {
      wellingmer_mall: "Wellingmer Mall",
      design_center: "Design Center",
      buy_more: "Visit Wellingmer Mall",
      jump_design_center: "Coming soon",
    },
    albumData: {
      title: "Company Environment",
      subtitle: "Wellingmer Company Album",
    },
    serviceData: {
      title: "Wellingmer has been deeply engaged in the industry.",
      subtitle:
        "WEILIMING has adhered to craftsmanship manufacturing for years, amassing a clientele of over",
      service_clients: "Service customers",
      service_outlets: "Service outlets",
      service_cities: "Covering cities",
      service_reviews: "Positive reviews",
    },
    pathersData: {
      title: "They chose Wellingmer",
      subtitle:
        "We have accumulated years of experience and service to the entire country.",
    },
    aboutData: {
      submit_title: "Message Submit",
      submit_subtitle:
        "You can submit your message at any time, thank you for trusting Wellingmer!",
      name_placeholder: "Please enter company name",
      phone_placeholder: "Please enter contact number",
      content_placeholder: "Please enter content",
      name_err: "Company name cannot be empty",
      phone_err: "Contact number cannot be empty",
      content_err: "Content cannot be empty",
      submit_success: "Submission successful",
      submit_error: "Submission failed, please try again later",
      service_time: "7x24 Hours Service",
      honor_title: "Honors",
      honor_subtitle:
        "Wellingmer has been deeply engaged in the industry for many years, and the best witness is the honor!",
    },
    footerData: {
      title_products: "Products",
      title_mall_and_design: "Mall And Design",
      title_udi_search: "UDI Search",
      title_follow_wellingmer: "Follow Wellingmer",
      title_contact_us: "Contact Us",
      wellingmer_mall: "Wellingmer Mall",
      design_center: "Design Center",
      phone: "Phone",
      email: "Email",
      address: "Address",
      query: "Query",
      query_placeholder: "Please enter the query content",
      more: "View More",
    },
    jobData: {
      title: "Waiting for you to challenge",
      subtitle:
        "Wellingmer invites talents to join us as partners, offering you more opportunities",
    },
    emptyTip: "There is currently no data available",
  },
};

const i18n = new VueI18n({
  locale: "zh", // 默认语言
  messages,
});

export default i18n;
